import {
  Role,
  MemberEmailStatus,
  RoleType,
  NetworkStatus,
} from '@tribeplatform/gql-client/types'

export const isMemberNotConfirmed = (member, role?: Role): boolean =>
  !!member &&
  member.emailStatus !== MemberEmailStatus.verified &&
  role?.type === RoleType.guest

export const isUrlPointsWithinApp = (url: string): boolean =>
  url.startsWith('/oauth/') === false &&
  url.startsWith('/auth') === false &&
  url.startsWith('/api/analytics') === false &&
  url.startsWith('/manifest.json') === false &&
  url.startsWith('sw.js') === false &&
  url.startsWith('favicon.ico') === false &&
  url.startsWith('/ssos/redirect') === false

export const isRestricted = (
  roleType: RoleType,
  networkStatus: NetworkStatus,
  url: string,
): boolean => {
  const isAdmin = roleType === RoleType.admin
  const isUnpublished = networkStatus === NetworkStatus.unpublished
  const isArchived = networkStatus === NetworkStatus.archived

  if (isArchived && !url.startsWith('/auth/restricted')) {
    return true
  }

  // For admins everything is allowed.
  // For guests and regular members, only login page is allowed.
  const isURLAllowed =
    isAdmin ||
    url.startsWith('/auth/login') ||
    url.startsWith('/auth/restricted')

  return isUnpublished && !isURLAllowed
}

export const loginUrlWithRedirect = (redirect?: string): string => {
  return `/auth/login${
    redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''
  }`
}
